export default __webpack_public_path__ + "static/media/ic_medium.439a4b67.svg";